export default "__VITE_ASSET__DVHKkqJg__"